export function sortByFirstLevelKey<T>(item1: T, item2: T, key: string): number {
    if (item1[key] < item2[key]) {
        return -1;
    }
    if (item1[key] > item2[key]) {
        return 1;
    }
    return 0;
}
